// This file is only a template for services.  Copy and paste this to your application's service .ts file and start off from there
// Rename all things with App_Name.
// Naming convention for services is "[App Name]Services.ts" i.e. UsersServices.ts, EntitlementServices.ts

import BaseService from '../../../services/BaseService';
import UrlUtilities from '../../../common/UrlUtilities';
import assign from 'object-assign';
var url = `${UrlUtilities.getApiUrl()}/UserProfileApi/api/Locale`;


var UserLocaleServices: IUserLocaleService = assign({}, BaseService, {   

    getLocale: function (localTimeZoneName: string, successCallback: any, errorCallback: any) {
        var that = this;
        this.get(`${url}/LocaleData`,
            {localTimeZoneNameHint: localTimeZoneName},
            function (retData: ILocaleData) {
                successCallback(retData);
            },
            function (error: any) {
                that.handleWebApiError(error);
                errorCallback(error);
            });
    },    

    updateLocalePreferences: function (localPreferences: ILocalePreferences, successCallback: any, errorCallback: any, ignoreDefaultError: (error: IServiceErrorObject) => boolean) {
        var that = this;
        this.post(`${url}/LocalePreferences`,
            localPreferences,
            function (retData: any) {
                successCallback(retData);
            },
            function (error: any) {
                if (!ignoreDefaultError(error)) {
                    that.handleWebApiError(error);
                }
                errorCallback(error);
            });
    },
    
});

export default UserLocaleServices;